import { render, staticRenderFns } from "./list_gcjs.vue?vue&type=template&id=9e143552&scoped=true"
import script from "./list_gcjs.vue?vue&type=script&lang=js"
export * from "./list_gcjs.vue?vue&type=script&lang=js"
import style0 from "./list_gcjs.vue?vue&type=style&index=0&id=9e143552&prod&lang=less"
import style1 from "./list_gcjs.vue?vue&type=style&index=1&id=9e143552&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e143552",
  null
  
)

export default component.exports